class Profiling.Dashboard.ResultRow extends Backbone.View
  initialize: ({model, currentUser, accountSettings, customerData}) ->
    @model = model
    @currentUser = currentUser
    @accountSettings = accountSettings || {}
    @customerData = customerData || {}
    @customerLinkClicked = ''
    @template = JST["backbone/templates/profiling/sessions/results"]
    @selectTagsElement = ''
    @chosenTagsElement = ''
    @selectGroupsElement = ''
    @chosenGroupsElement = ''
    @hasMouse = true
    @isExcluded = false
    @noteAdded = false
    @newCaseToCreate = {}
    @tagsEditorIsCollapsed = true
    @groupsEditorIsCollapsed = true

  tagName: "section"
  className: "content"
  events:
    'click .delete': 'onDelete'
    'click .customer': 'onClickCustomer'
    'click .view-profile': 'showProfile'
    'click .view-conversations': 'showConversation'
    'click .view-contents': 'showContent'
    'click .escalate_case': '_onClickEscalateButton'
    'click .exclude_case': '_onClickExcludeButton'
    'click .children-comments': '_childrenCommentsPreview'
    'click .twitter-related-children': 'twitterRelatedChildrenPreview'
    'click .sc-view-groups': '_toggleGroups'

  onMouseover: =>
    @hasMouse = true

  onMouseleave: =>
    @hasMouse = false
    @waitAndDetachTags() if @selectTagsElement == ''
    @waitAndDetachGroups() if @selectGroupsElement == ''

  onMouseoverTags: ->
    return if @$el.find('.sc-tags .tags-editor div.chosen-container').hasClass('chosen-with-drop')
    @$el.find('.sc-tags .tags-editor div.chosen-container').append(@chosenTagsElement) if @chosenTagsElement
    @chosenTagsElement = ''
    @$el.find('.sc-tags .tags-editor-possible').prepend(@selectTagsElement) if @selectTagsElement
    @selectTagsElement = ''

  onMouseoverGroups: ->
    return if @$el.find('.sc-groups .tags-editor div.chosen-container').hasClass('chosen-with-drop')
    @$el.find('.sc-groups .tags-editor div.chosen-container').append(@chosenGroupsElement) if @chosenGroupsElement
    @chosenGroupsElement = ''
    @$el.find('.sc-groups .tags-editor-possible').prepend(@selectGroupsElement) if @selectGroupsElement
    @selectGroupsElement = ''

  waitAndDetachGroups: ->
    setTimeout =>
      @detachInvisibleGroupsElements() unless @hasMouse
    , 10000

  detachInvisibleTagsElements: ->
    @$el.find('.sc-tags .tags-editor div.chosen-container').removeClass('chosen-with-drop')
    @chosenTagsElement = @chosenTagsElement || @$el.find('.sc-tags .tags-editor div.chosen-container div.chosen-drop').detach()
    @selectTagsElement = @selectTagsElement || @$el.find('.sc-tags .tags-editor select.tags').detach()

  detachInvisibleGroupsElements: ->
    @$el.find('.sc-groups .tags-editor div.chosen-container').removeClass('chosen-with-drop')
    @chosenGroupsElement = @chosenGroupsElement || @$el.find('.sc-groups .tags-editor div.chosen-container div.chosen-drop').detach()
    @selectGroupsElement = @selectGroupsElement || @$el.find('.sc-groups .tags-editor select.tags').detach()

  showContext: =>
    @contextView.remove() if @contextView?
    contentLink = @$el.find('.content-link').length > 0 && @$el.find('.content-link')[0].href
    @contextView = Monitoring.Views.SocialContentContextView.for(@model, contentLink)
    @$el.find('.context-container').append(@contextView.render().el)
    @contextView.newSearch()

  showProfile: (event) =>
    @$el.find('#user-profile').remove()
    @userProfileView = new Customer.Users.UserProfileView
      source: @model.type()
      id: @model.userId()
      session: 'monitoring'
    @$el.append(@userProfileView.render().el)
    @userProfileView.show()

  showConversation: (event) =>
    @$el.find('#user-profile').remove()
    @userProfileView = new Customer.Users.UserProfileView
      source: @model.type()
      id: @model.userId()
      openTab: 'conversations-tab'
      session: 'monitoring'
    @$el.append(@userProfileView.render().el)
    @userProfileView.show()

  showContent: (event) =>
    @$el.find('#user-profile').remove()
    @userProfileView = new Customer.Users.UserProfileView
      source: @model.type()
      id: @model.userId()
      openTab: 'contents-tab'
      session: 'monitoring'
    @$el.append(@userProfileView.render().el)
    @userProfileView.show()

  onChangeTags: (currentlySelectedTagCodes) =>
    @model.set('tags', currentlySelectedTagCodes)
    @moderate(=> @_renderTags())

  onChangeGroups: (currentlySelectedGroups) =>
    @model.set('labels', currentlySelectedGroups)
    @moderate(=> @_renderLabels())

  moderate: (callback) =>
    new Monitoring.Models.SocialContentModerator([this]).moderate(@model.isReviewMode(), callback)

  onDelete: =>
    swal({
        title: "#{I18n.t('monitoring.dashboard.social_content.actions.delete_case.s_title')}?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: I18n.t('monitoring.dashboard.social_content.actions.delete_case.s_confirm'),
        closeOnConfirm: true
      }, =>
        new Monitoring.Models.SocialContentModerator([this]).delete()
        $(@$el).remove()
    )

  assignedSelector: ->
    @$el.find('#assigned_to_from_monitoring')

  processCustomerLink: (callbackIfNotInCustomer = $.noop) ->
    link = @customerLinkClicked || @$el.find('.customer')
    buttonText = link.text()

    if link.data('processed')
      return true

    assignDialog = @$el.find("#assign_from_monitoring") # modal
    assignedSelector = @assignedSelector()

    link.text('Checking...')
    $.ajax(
      type: 'POST',
      url: '/customer/api/check_if_exists.json'
      data: @basicDataForConversations()
      success: (response) =>
        @checkedIfExistsInCustomer = true
        if response.conversation && response.found
          link.data('processed', true)
          @isInCustomer = true
          if response.can_access
            link.text('Go to case')
            link.attr('href', "/customer/dashboard#/conversation/#{response.conversation}")
          else
            link.text('Exists')
            link.removeAttr('href')
            link.css('cursor', 'default')
          return true
        else
          @isInCustomer = false
          link.text(buttonText)
          callbackIfNotInCustomer(assignDialog, assignedSelector)
          return false
    )

  _onClickExcludeButton: =>
    if !@excludeButtonIsActive() # Active class not added yet
      @exclude()
    else
      @include()

  getActiveTags: ->
    @model.set('tags', @socialContentTagsView.currentlySelectedTagCodes) if (@socialContentTagsView && @model.isReviewMode())
    @model.tags(false) # whole tags, not just codes

  getLabels: ->
    @model.set('labels', @socialContentGroupsView.currentlySelectedTagCodes) if (@socialContentGroupsView && @model.isReviewMode())
    @model.get('labels')

  getSentiment: ->
    @model.getSentiment(true) # sentiment value

  sentimentName: ->
    @model.sentiment()

  onDeleteSuccess: (data) ->
    @trigger('updateResultCount', -1)

  onClickCustomer: (evt) =>
    if !@showPopupForNewCases() && @$el.find('.create_case_li').hasClass('active')
      @$el.find('.create_case_li').removeClass('active')
      @onClickCancelCase()
      return true

    link = $(evt.currentTarget) || @$el.find('.customer')
    @customerLinkClicked = link

    if link.data('processed')
      return true

    assignDialog = @$el.find("#assign_from_monitoring")
    assignedSelector = @assignedSelector()

    if @checkedIfExistsInCustomer
      @showAssignDialogOrSkip(assignDialog, assignedSelector)
    else
      @processCustomerLink(@showAssignDialogOrSkip)

  showAssignDialog: (assignDialog, assignSelector) =>
    assignDialog.modal()
    assignSelector.chosen(width: '300px')
    setTimeout =>
      @$el.find('.new_case_note').focus()
    , 500

  showAssignDialogOrSkip: (assignDialog, assignSelector) =>
    if @showPopupForNewCases()
      @showAssignDialog(assignDialog, assignSelector)
    else
      @createConversation(false)

  createNewCase: =>
    if Object.keys(@newCaseToCreate).length == 0
      return
    link = @customerLinkClicked || @$el.find('.customer')
    buttonText = link.text()
    link.text('Working...')
    $.ajax(
      type: 'POST',
      url: '/customer/api/get_or_create.json'
      data: @newCaseToCreate
      success: (response) =>
        if response.conversation
          @conversation = response.conversation
          link.data('processed', true)
          if response.can_access
            link.text('Go to case')
            link.attr('href', "/customer/dashboard#/conversation/#{response.conversation}")
          else
            link.text('Created')
            link.removeAttr('href')
            link.css('cursor', 'default')
        else
          link.text(buttonText)
          alert('No conversation created')
          console.log('Response from customer api:')
          console.log(response)
    )

  getDataForNewCase: ->
    if Object.keys(@newCaseToCreate).length == 0
      return null
    else
      @newCaseToCreate

  basicDataForConversations: ->
    {content_id: @model.id, current_topic: @model.get('topics')[0].id, force: true}

  createConversationUnassigned: (note) ->
    @finishNewCaseCreation({}, note)

  createConversationAssignedToUser: (user_id, note) ->
    @finishNewCaseCreation({user_to_assign: user_id}, note)

  createConversationAssignedToUserGroup: (group_id, note) ->
    @finishNewCaseCreation({user_group_to_assign: group_id}, note)

  finishNewCaseCreation: (data, note) ->
    data.note = note if note && note.trim() != ''
    @newCaseToCreate = _.extend(@basicDataForConversations(), data)
    @changeCancelButtonText('Remove') if @model.isReviewMode()
    @createNewCase() unless @model.isReviewMode() # the creation will happen after confirming current batch

  showPopupForNewCases: ->
    return @accountSettings.show_popup_on_creation

  onClickCreateCase: ->
    @createConversation()

  createConversation: (showDialog = true) ->
    if @model.isReviewMode()
      @$el.find('.create_case_li').addClass('active')
    if showDialog
      if @assignmentIsDefined()
        @createConversationAssignedTo(@assignedSelector().val(), @$el.find('.new_case_note').val())
      else
        @createConversationUnassigned(@$el.find('.new_case_note').val())
    else
      @createConversationUnassigned()

  onClickCancelCase: ->
    if @model.isReviewMode()
      @newCaseToCreate = {}
      @changeCancelButtonText('Cancel')
      @resetNewCaseModal()
      @$el.find('.create_case_li').removeClass('active')

  changeCancelButtonText: (newText) ->
    setTimeout =>
      @$el.find('#cancel_case').html(newText)
    , 500

  createConversationAssignedTo: (user_or_group, note = '') ->
    if @isUser(user_or_group)
      @createConversationAssignedToUser(user_or_group, note)
    else
      @createConversationAssignedToUserGroup(user_or_group, note)

  _childrenCommentsPreview: ->
    # @searchQuery = new Monitoring.Models.SearchQuery({}, { use_defaults: false, defaultCharts: @defaultChartsByAccount })
    dashboardPreview = new Monitoring.Views.DashboardPreviewResultsView({ searchQuery: @searchQuery, facets: {}, defaultChart: @defaultChartsByAccount })
    previewContainer = @$el.find('#children_preview_container')
    previewContainer.html(dashboardPreview.render().el)
    # dashboardPreview.setSearchQuery(@getChildrenQuery())
    dashboardPreview.newSearch()

  getChildrenQuery: ->
    # query = @searchQuery.deepCopy()
    query.addParentPostId(@model.numeric_id())
    query.removeDateFromRealtime()
    query.addDateFrom(Date.create(@model.created_at()))
    query.addDateTo(Date.now())
    return query

  twitterRelatedChildrenPreview: (event)=>
    # event.stopPropagation()
    # @searchQuery = new Monitoring.Models.SearchQuery({}, { use_defaults: false, defaultCharts: @defaultChartsByAccount })
    # dashboardPreview = new Monitoring.Views.DashboardPreviewResultsView
    #   searchQuery: @searchQuery
    #   facets: {}
    #   defaultChart: @defaultChartsByAccount
    #   drillDownMode: true
    # @$el.find('.children-preview-container').html(dashboardPreview.render().el)
    # dashboardPreview.setSearchQuery(@getRelatedChildrenQuery())
    dashboardPreview.newSearch()

  getRelatedChildrenQuery: ->
    # query = @searchQuery.deepCopy()
    query.addChildCommentsFor(@model.cassandra_id())
    query.removeDateFromRealtime()
    query.addDateFrom(Date.create(@model.created_at()))
    query.addDateTo(Date.now())
    query

  isUser: (user_or_group) ->
    _.contains(_.pluck(@customerData.users, 'id'), parseInt(user_or_group))

  assignmentIsDefined: ->
    @mustAssign() and @userOrGroupSelected()

  mustAssign: ->
    checkbox = @$el.find('#assigned_or_not')
    if checkbox[0]
      checkbox[0].checked
    else
      false

  userOrGroupSelected: ->
    @assignedSelector().val() != "null"

  onChangeAssignedSelectorOrNote: ->
    checkboxAssigned = @$el.find('#assigned_or_not')
    assignmentDiv = @$el.find('.new_case_assignment')
    buttonCreateCase = @$el.find('#create_case')
    note = @$el.find('.new_case_note')
    if @mustAssign()
      assignmentDiv.css("visibility", "visible")
    else
      assignmentDiv.css("visibility", "hidden")
    setTimeout =>
      @$el.find('.new_case_note').focus()
    , 500
    selectionOk = (not @accountSettings.assign_cases_on_creation) or (not @mustAssign()) or @assignmentIsDefined()
    noteOk = if @accountSettings.notes_are_mandatory then (note.val() || '').trim() != '' else true
    if selectionOk and noteOk
      buttonCreateCase.attr("disabled", false).removeClass("ui-state-disabled")
    else
      buttonCreateCase.attr("disabled", true).addClass("ui-state-disabled")

  onModerationSuccess: (data) ->
    @model.set(data)
    @model.set('edit_tags', false)
    @model.set('review_mode', false)
    @_renderDetails()

  onModerationError: (data) ->
    @model.set('edit_tags', false)
    @render()
    showError(data.errors)

  destroy: ->
    @model.destroy()
    this.remove()
    return false

  shouldBeEscalated: ->
    return @$el.find('.escalate_case').hasClass('active')

  excludeButtonIsActive: ->
    return @$el.find('.exclude_case').hasClass('active')

  exclude: ->
    @isExcluded = true
    @$el.addClass('excluded')
    @$el.find('.exclude_case').replaceWith("<a class='exclude_case btn-excluded btn nohover btn-mini active' data-toggle='button'><i class='fa fa-arrow-left exclude-action'></i> #{I18n.t('monitoring.dashboard.social_content.actions.exclude_case.excluded')}</a>")
    @toggleBlockAllBut('.exclude_case')
    swal({
        title: "#{I18n.t('monitoring.dashboard.social_content.actions.exclude_case.s_title')}?",
        type: 'info',
        showCancelButton: true,
        confirmButtonClass: 'btn-primary',
        confirmButtonText: I18n.t('monitoring.dashboard.social_content.actions.exclude_case.s_confirm'),
        cancelButtonText: I18n.t('monitoring.dashboard.social_content.actions.exclude_case.s_cancel'),
        closeOnConfirm: true
      }, =>
        @showNotes()
    ) unless @noteAdded

  include: =>
    @isExcluded = false
    @$el.find('.exclude_case').removeAttr('active')
    @$el.find('.exclude_case').replaceWith('<a class="exclude_case btn-excluded btn nohover btn-mini" data-toggle="button"><i class="fa fa-arrow-left exclude-action"></i> Exclude</a>')
    @$el.removeClass('excluded')
    @toggleBlockAllBut('.exclude_case')

  _renderAvatar: ->
    if @model.type() == 'twitter'
      avatar = new Monitoring.Views.TwitterAvatarView({socialContent: @model})
    else #IF the number of Avatar implementation rises, it should be considered to make a factory and delegate the cosntruction logic.
      avatar = new Monitoring.Views.GenericAvatarView({socialContent: @model})
    @$el.find('.sc-avatar').html(avatar.render())

  _renderSentiment: ->
    @sentimentView = new Monitoring.Views.SentimentView
      model: @model
      centerToolbar: true
    @$el.find('div.sentiment').html @sentimentView.render().el
    @_changeTextBackground @sentimentName().toLowerCase()
    @listenTo @sentimentView, 'sentiment:changed', @_changeTextBackground
    @$el.find('em.evidence').tooltip({
      'selector': '',
      'placement': 'bottom',
      'html': true
    })

  _changeTextBackground: (sentiment) ->
    @$el.find('.sc-text')
      .removeClass(@_sentimentHTMLClasses())
      .addClass("background-sentiment-#{sentiment.toLowerCase()}")
    @$el.find('.sentiment-icon')
      .removeClass(@_sentimentIconHTMLClasses())
      .addClass("sentiment-#{sentiment.toLowerCase()}")

  _sentimentHTMLClasses: ->
    ("background-sentiment-#{sentiment}" for sentiment in ['positive', 'negative', 'neutral', '']).join(' ')

  _sentimentIconHTMLClasses: ->
    ("sentiment-#{sentiment}" for sentiment in ['positive', 'negative', 'neutral', '']).join(' ')
  
  _renderTags: ->
    @loadTagsView()
    @listenTo(@socialContentTagsView, 'changed:tags', @onChangeTags)
    @$el.find('.sc-tags').html(@socialContentTagsView.render())

  _renderLabels: ->
    @loadGroupsView()
    @listenTo(@socialContentGroupsView, 'changed:tags', @onChangeGroups)
    @$el.find('.sc-groups').html(@socialContentGroupsView.render())

  loadTagsView: =>
    @socialContentTagsView = new Monitoring.Dashboard.SocialContentTagsView(
      possibleTags: @model.possibleTags()
      selectedTagCodes: @model.get('tags')
      suggestedTags: @model.suggestedTags()
      mode: if @model.isReviewMode() then 'review' else 'explore'
      withIconAndLabel: true
      toggleableControls: true
    )
    @listenTo(@socialContentTagsView, 'changed:editorVisibility', @updateTagsContainerStyle)

  loadGroupsView: =>
    @socialContentGroupsView = new Monitoring.Dashboard.SocialContentTagsView(
      possibleTags: _.map(Keepcon.groups, (group) -> {code: group, description: group})
      selectedTagCodes: @getLabels()
      suggestedTags: []
      mode: if @model.isReviewMode() then 'review' else 'explore'
      withIconAndLabel: true
      groupsInsteadOfTags: true
      toggleableControls: true
    )
    @listenTo(@socialContentGroupsView, 'changed:editorVisibility', @updateGroupsContainerStyle)

  updateTagsContainerStyle: (visible) =>
    @tagsEditorIsCollapsed = !visible
    @updateTagsAndGroupsContainerStyle()

  updateGroupsContainerStyle: (visible) =>
    @groupsEditorIsCollapsed = !visible
    @updateTagsAndGroupsContainerStyle()

  updateTagsAndGroupsContainerStyle: =>
    @$el.find('.sc-groups-and-tags-container').toggleClass('both-collapsed', @tagsEditorIsCollapsed && @groupsEditorIsCollapsed)

  render: ->
    @$el.html(@template(@_extendedModel())).addClass(@model.socialNetworkName())
    @$el.addClass('hide') if @model.get('deleted')
    @_renderDetails()
    @_renderAvatar()
    @_renderActions()
    @updateTagsAndGroupsContainerStyle()
    @_renderText()
    @

  _extendedModel: ->
    extendedModel = @model
    extendedModel.current_user = @currentUser
    extendedModel.account_settings = @accountSettings
    extendedModel.users_of_customer = @customerData.users
    extendedModel.users_groups_of_customer = @customerData.usersGroups
    extendedModel.new_case_note_placeholder = () ->
      if @account_settings.notes_are_mandatory then "Add a note (mandatory)" else "Add a note..."
    extendedModel

  _renderDetails: ->
    @detailsView = new Profiling.Dashboard.ResultRowDetails(model: @model)
    @$el.find('.sc-details').replaceWith(@detailsView.render().el)

  _renderActions: ->
    @actionsView = new Profiling.Dashboard.ResultRowActions
      el: @$el.find('.sc-actions')
      model: @model
      main: this
    @actionsView.render()

  resetNewCaseModal: ->
    canAssign = @accountSettings.assign_cases_on_creation
    userToAssign = @accountSettings.default_user_to_assign
    groupToAssign = @accountSettings.default_users_group_to_assign

    if canAssign and (userToAssign != 0 or groupToAssign != 0) # if a default is configured
      if userToAssign == 0
        @selectUserOrGroupToAssign(groupToAssign)
      else
        @selectUserOrGroupToAssign(userToAssign)
    @$el.find('#assigned_or_not').prop('checked', 'checked')
    @$el.find('.new_case_note').val('')
    @onChangeAssignedSelectorOrNote()
    # TODO cambiar el nombre por "Me" ?

  selectUserOrGroupToAssign: (user_or_group_id) ->
    @assignedSelector().val(user_or_group_id).trigger('chosen:updated')

  processLinksIsEnabledForCurrentAccount: ->
    @accountSettings.process_customer_links

  customerEnabled: ->
    @customerData.enabledForCurrentAccount and @_customerAllowedForThisContent()

  _customerAllowedForThisContent: ->
    @_customerAllowedForType() or @_customerAllowedForGroupType()

  _customerAllowedForType: ->
    @customerData.settings.allowed_types.indexOf(@model.type()) != -1

  _customerAllowedForGroupType: ->
    @customerData.settings.allowed_group_types.indexOf(@model.groupType()) != -1

  _renderModerationActions: ->
    @$el.find('.moderation_comment_li').tooltip({
      'selector': '',
      'placement': 'bottom'
    })
    @$el.find('.moderation_comment').on('click', =>
      swal('Moderation comment', @model.get('moderation_comment'))
    )

  _onClickEscalateButton: (event) ->
    if !@shouldBeEscalated() # Active class no added yet
      textareaId = 'textarea_' + @cid
      @_renderSwal(textareaId)
      $('#' + textareaId).focus()
    else                     # Active class added
      @model.set('moderation_comment', null)
      @$el.find('.escalate_case').removeClass('active')
      @$el.find('.escalate_case').replaceWith("<a class='escalate_case btn-escalated btn nohover btn-mini' data-toggle='button'><i class='fa fa-share-square-o escalate-action'></i> #{I18n.t('monitoring.dashboard.social_content.actions.escalate_case.escalate')}</a>")
      @$el.removeClass('escalated')
      @toggleBlockAllBut('.escalate_case')

  _renderSwal: (textareaId) ->
    swal({
        title: I18n.t('monitoring.dashboard.social_content.actions.escalate_case.s_title'), html: true,
        text: "<div>#{I18n.t('monitoring.dashboard.social_content.actions.escalate_case.s_text.label')}:</div> <textarea id='#{textareaId}' class='moderation_comment' placeholder='#{I18n.t("monitoring.dashboard.social_content.actions.escalate_case.s_text.placeholder")}' rows='5' cols='100'></textarea><div id='#{textareaId}-error' style='display:none' class='sa-error-container show'><div class='icon'>!</div><p>#{I18n.t('monitoring.dashboard.social_content.actions.escalate_case.s_text.message')}</p></div>",
        closeOnConfirm: false, showCancelButton: true, allowOutsideClick: true,  animation: "slide-from-top" 
      }, (accepted) =>
        inputValue = $('#' + textareaId).val()
        if (inputValue != '' && accepted && inputValue)
          @model.set('moderation_comment', inputValue)    # TODO: Escapar cosas?
          @$el.find('.escalate_case').replaceWith("<a class='escalate_case btn-escalated btn nohover btn-mini active' data-toggle='button'><i class='fa fa-share-square-o escalate-action'></i>#{I18n.t('monitoring.dashboard.social_content.actions.escalate_case.escalated')}</a>")
          @$el.addClass('escalated')
          @toggleBlockAllBut('.escalate_case')
          swal({ title: '', text: '', timer: 1, showConfirmButton: false }) # HACK: In order to close parent swal!
        else if accepted and inputValue == ""
          $('#' + textareaId + '-error').show()
          return false
        else
          @$el.find('.escalate_case').removeClass('active')
          @$el.removeClass('escalated')
          @model.set('moderation_comment', null)
    )

  onAvatarError: (evt) ->
    $(evt.currentTarget).attr('src', '/assets/default-avatar.gif')

  toggleBlockAllBut: (selector) =>
    allSelectors = [
      '.bottom',
      '.create-conversation',
      '.exclude_case',
      '.escalate_case',
      '.reply_li',
      '.moderation_comment_li',
      '.notes_li',
      '.attributes',
      '.sentiment-icon',
    ]
    selectorForElementsToBlock = _.without(allSelectors, selector).join(',')
    @$el.find(selectorForElementsToBlock).toggleClass('unclickable')

  isExploreMode: ->
    $('.dashboard-modes button.active').attr('id') == 'explore'

  _renderEmailSummary: ->
    return unless @model.isEmail()
    @emailSummaryView = new Monitoring.Views.SocialContents.SocialContentEmailSummaryView
      email: @model
    @$el.find('.sc-main').prepend(@emailSummaryView.render().el)

  _renderText: ->
    _.defer @_activateShortener
    @_renderRetweet() if @model.isRetweet()
    @_renderAttachments() if @_showAttachmentsBox()

  _activateShortener: =>
    $shortener = @$el.find '.sc-text-shortener'
    if $shortener.height() > 60
      $shortener.parent().addClass 'sc-shortened'

  _toggleShortener: (event) ->
    $seeMore = $(event.target)
    $container = $seeMore.closest('.sc-text').toggleClass 'sc-expanded'
    $seeMore.text(I18n.t("monitoring.dashboard.social_content.#{
      if $container.hasClass('sc-expanded') then 'see_less' else 'see_more'
    }"))
    false

  _renderRetweet: ->
    @retweetView = new Monitoring.Views.SocialContents.SocialContentRetweetView
      contentEnhancer: @model.getContentEnhancer
      originalAuthor: @model.getOriginalAuthor()
    @$el.find('.sc-text-shortener').prepend(@retweetView.render().el)

  _renderAttachments: ->
    @attachmentsView = new Monitoring.Views.SocialContents.SocialContentAttachmentsView
      links: @model.links?()
      emailFiles: @_emailAttachments()
      facebookAttachments: @_facebookAttachments()
    @$el.find('.sc-text').append(@attachmentsView.render().el)

  _emailAttachments: ->
    return null unless @_hasEmailAttachments()
    return @model.getAttachments('files') if @model.isNewEmailVersion()
    @model.getValues()['attachments']

  _facebookAttachments: ->
    return null unless @_hasFacebookAttachments()
    attachments = _.object([type, @model.getAttachments(type)] for type in ['images', 'videos', 'audios', 'files'])
    extend(attachments, shares: @model.getShares())

  _showAttachmentsBox: ->
    @_hasLinks() or @_hasEmailAttachments() or @_hasFacebookAttachments()

  _hasLinks: ->
    @model.links?().length

  _hasEmailAttachments: ->
    @model.isEmail() and @model.hasAttachments?()

  _hasFacebookAttachments: ->
    @model.hasFacebookAttachments?() or @_hasFacebookShares()

  _hasFacebookShares: ->
    @model.isFacebook?() and @model.hasShares?() and @model.getShares().length

  _renderMedia: ->
    @mediaView = new Monitoring.Views.SocialContents.SocialContentMediaView
      socialContent: @model
    @$el.find('.sc-media-container').append(@mediaView.render().el)

  _toggleGroups: ->
    @socialContentGroupsView.showTagsEditor()

  _editTags: =>
    @socialContentTagsView.showTagsEditor()

  _hideAllActions: ->
    actions = ['.sc-links', '.sc-actions', '.sc-selector'].join(', ')
    @$el.find(actions).addClass('hidden')

  _isPreviewMode: ->
    @model.get('preview')?
